import { unformat } from '@react-input/mask'

import {
  EMPTY_STRING,
  PHONE_INTERNATIONAL_FORMAT_SYMBOL,
} from '../../../constants/common'

// The `+` character should be excluded from the search string because the select options do not have it in their data.
function getPhoneSelectSearchValue(search) {
  return search
    .toLowerCase()
    .replace(PHONE_INTERNATIONAL_FORMAT_SYMBOL, EMPTY_STRING)
}

export function getNextValue({ country, maskOptions, nextValue }) {
  return nextValue
    ? country.phoneCode.concat(unformat(nextValue, maskOptions))
    : nextValue
}

export function filterPhoneSelectCountryOptions(item, search) {
  const searchValue = getPhoneSelectSearchValue(search)

  return (
    item.label.toLowerCase().includes(searchValue) ||
    item.phoneCode.includes(searchValue)
  )
}
